var _linearGradient, _radialGradient, _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 202,
    viewBox: "0 0 131 202",
    width: 131,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 65.5,
    x2: 65.5,
    y1: 1,
    y2: 201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523e35",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-45.0701281 -38.42691363 24.75091107 -29.02982901 101.551 174.971)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0f0f0f",
    height: 200.548,
    rx: 14.8858,
    width: 129.548,
    x: 0.726027,
    y: 0.726027
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 200.548,
    rx: 14.8858,
    stroke: "url(#a)",
    strokeWidth: 0.547945,
    width: 129.548,
    x: 0.726027,
    y: 0.726027
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 200.548,
    rx: 14.8858,
    stroke: "url(#b)",
    strokeWidth: 0.547945,
    width: 129.548,
    x: 0.726027,
    y: 0.726027
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.1272 187.496c.1739 0 .3478.118.3478.354v2.589c0 1.149-.6769 1.832-1.7761 1.832-.4595 0-.9129-.13-1.211-.304-.1366-.081-.1987-.199-.1987-.31 0-.143.1056-.267.2795-.267.1987 0 .503.26 1.0805.26.739 0 1.1178-.428 1.1178-1.211v-.347c-.1801.441-.6334.72-1.2171.72-.975 0-1.5836-.751-1.5836-1.683 0-.956.6334-1.67 1.6208-1.67.4782 0 .9377.236 1.1799.652v-.242c0-.249.1801-.373.3602-.373zm-1.3972 2.676c.6023 0 1.0308-.447 1.0308-1.037 0-.583-.4285-1.03-1.0308-1.03-.6086 0-1.0433.428-1.0433 1.03 0 .609.4347 1.037 1.0433 1.037zm5.5966-1.21c.0249.248-.1056.378-.3478.378h-2.2294c.0187.522.4658.882.9999.882.385 0 .6458-.174.8259-.416.0683-.093.1552-.13.236-.13.1552 0 .3043.149.3043.316 0 .069-.0249.137-.0808.205-.267.329-.7017.615-1.2917.615-.9811 0-1.6953-.664-1.6953-1.67 0-.957.6831-1.683 1.6457-1.683.9066 0 1.5339.583 1.6332 1.503zm-1.6332-.926c-.5155 0-.9005.348-.9377.826h1.8816c-.0373-.472-.4099-.826-.9439-.826zm5.7056-.577c.6272 0 1.1923.391 1.1923 1.298v1.658c0 .242-.1801.372-.3602.372-.18 0-.3601-.13-.3601-.372v-1.547c0-.608-.2981-.795-.6086-.795-.3975 0-.6583.299-.6583.833v1.509c0 .242-.1801.372-.3602.372s-.3602-.13-.3602-.372v-1.547c0-.608-.298-.795-.6085-.795-.3975 0-.6521.292-.6583.833v1.521c0 .23-.1801.354-.3602.354s-.3602-.124-.3602-.354v-2.577c0-.236.1863-.354.3664-.354.1739 0 .354.112.354.341v.125c.1677-.323.472-.503.8694-.503.385 0 .7266.167.9067.552.1863-.347.5278-.552 1.006-.552zm1.7338.366c0-.161.1366-.298.298-.298h1.8817c.1925 0 .3105.093.3105.23 0 .056-.0186.124-.0683.198l-1.4345 2.193h1.273c.1677 0 .3043.136.3043.304 0 .161-.1366.298-.3043.298h-1.8816c-.1987 0-.3229-.093-.3229-.236 0-.056.0248-.124.0683-.192l1.4407-2.193h-1.2669c-.1614 0-.298-.136-.298-.304z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m116.203 183.525c-.023.016-.041.039-.05.066l-.133.361c-.103.283-.267.54-.48.754-.214.213-.471.377-.754.48l-.361.133c-.027.009-.05.027-.066.05s-.025.051-.025.08c0 .028.009.056.025.079s.039.041.066.05l.361.133c.283.103.54.267.754.48.213.214.377.471.48.754l.133.361c.009.026.027.049.05.066.023.016.051.025.08.025.028 0 .056-.009.079-.025.023-.017.041-.04.05-.066l.133-.361c.103-.283.267-.54.48-.754.214-.213.471-.377.754-.48l.361-.133c.026-.009.049-.027.066-.05.016-.023.025-.051.025-.079 0-.029-.009-.057-.025-.08-.017-.023-.04-.041-.066-.05l-.361-.133c-.283-.103-.54-.267-.754-.48-.213-.214-.377-.471-.48-.754l-.133-.361c-.009-.027-.027-.05-.05-.066s-.051-.025-.079-.025c-.029 0-.057.009-.08.025zm-5.228 1.914h2.951v.008c0 .113.034.223.099.315s.156.162.261.2h.001l.36.132c.227.083.433.215.604.386.171.17.302.377.385.603l.132.36v.001c.039.105.109.197.201.261.092.065.202.099.314.099.113 0 .223-.034.315-.099.092-.064.162-.156.2-.261v-.001l.132-.36c.072-.197.181-.379.321-.536l1.18 1.377c.301.35.295.869-.012 1.214l-4.305 4.821c-.367.411-1.009.411-1.375 0l-4.306-4.821c-.307-.345-.312-.864-.012-1.214l1.854-2.163c.175-.204.43-.322.7-.322z",
    fill: "#d2d2d2",
    fillRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFront);
export default __webpack_public_path__ + "static/media/card_front.b8293339956de7669eae28c671d59e89.svg";
export { ForwardRef as ReactComponent };